import React, { Suspense } from 'react';
import { Subwindow } from '../components/layout/Subwindow/Subwindow';
import ViewportDepartmentsProvider from '../components/features/Datamanager/ViewportDepartmentNetwork/ViewportDepartments';
import { ConflictPanel } from '../components/layout/MainPanels/ConflictPanel/ConflictPanel';
import { Inspector } from '../components/features/Datamanager/Inspector/Inspector';
import { openModal } from '../components/features/Modal/modal.slice';
import { ExecButton } from '../components/ui/ExecButton/ExecButton';
import { useAppDispatch, useAppSelector } from '../redux/hooks';
import { useSendWebsocketMessage } from '../components/features/WebSocket/hooks/useSendWebsocketMessage';
import { useWebSocket } from '../components/features/WebSocket/hooks/useWebSocket';
import { rootState } from '../redux/store';

export const DatamanagerScreen = () => {
    const { socketRef } = useWebSocket('Data manager');
    
    const dispatch = useAppDispatch();
    

    return (
        <ConflictPanel
            firstColumn={'auto'}
            secondColumn={'400px'}
            firstElem={<ViewportDepartmentsProvider />}
            secondElem={
                <Subwindow
                    isRelative={true}
                    hasProjectPath={false}
                    headerSettings={true}
                    isSingle={true}
                    title={'Inspector'}
                    headerMenu={
                        <>
                        </>
                    }
                    main={
                        <Suspense>
                            <Inspector socketRef={socketRef}/>
                        </Suspense>
                    }
                    footer={<></>}
                />
            }
        />
    );
};
